import { Colors, Language, Lightning, Router, Log } from '@lightningjs/sdk'
import Slider from '../components/grid/Slider'
import Strip from '../components/grid/Strip'

export default class Playlists extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      Header: {
        w: 1920,
        h: 180,
        rect: true,
        color: Colors('PageBG').get(),
        zIndex: 10,
        Title: {
          x: 260,
          y: 62,
          w: 1450,
          h: 75,
          color: Colors('white').get(),
          text: {
            text: Language.translate('PlaylistTitle'),
            textAlign: 'left',
            fontSize: 55,
            fontFace: 'OpenSansBold',
            lineHeight: 75,
          },
        },
      },
      PlaylistGrid: {
        w: 1660,
        h: 895,
        x: 260,
        y: 183,
        type: Slider,
        orientation: 'vertical',
        scrollOffsetStart: 0,
        scrollOffsetEnd: 621,
        spacing: 0,
        signals: { filled: true, requestMoreItems: true },
      },
    }
  }

  set items(data) {
    // this._dataSet = data;
    this._items = data.playlists

    if (data) {
      this._buildSliders()
    } else {
      this.noData = true
    }

    this._setState('Idle')
  }

  _init() {
    this.widgets['sidemenu'].activeMenuItem = 2

    this._setState('Idle')
  }

  _focus() {
    this._setState('PlaylistGrid')
  }

  _buildSliders() {
    const gridRows = this._items.map(row => {
      let gridRow = {
        data: [],
        title: row.title,
        type: row.type || 'playlist',
      }

      gridRow.data = row.playlistItems.map(rowItem => {
        return { item: rowItem }
      })

      return gridRow
    })

    if (gridRows) {
      this.noData = false

      this.tag('PlaylistGrid').items = gridRows.map((collection, idx) => {
        return {
          ref: `SliderRow-${idx}`,
          h: 621,
          w: 1660,
          type: Strip,
          index: idx,
          items: collection,
          coverType: 'playlist',
          signals: { filled: 'stripFilled' },
        }
      })
    }
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({ type: 'playbackStopped', Notification: true })
    Router.focusWidget('ErrorBox')
  }
  historyState(params) {
    if (params) {
      if (params.mainIndex) {
        this.tag('PlaylistGrid').index = params.mainIndex
      }
      if (params.crossIndex) {
        this.tag('PlaylistGrid').items[this.tag('PlaylistGrid').index].sliderIndex =
          params.crossIndex
      }
    } else {
      return {
        mainIndex: this.tag('PlaylistGrid').index,
        crossIndex: this.tag('PlaylistGrid').items[this.tag('PlaylistGrid').index].sliderIndex,
      }
    }
  }

  _inactive() {
    this.stage.gc()
  }

  static _states() {
    return [
      class Idle extends this {
        filled() {
          this._setState('PlaylistGrid')
        }

        stripFilled() {
          this._setState('PlaylistGrid')
        }
      },

      class PlaylistGrid extends this {
        $enter() {
          this._currRow = this.tag('PlaylistGrid').index
        }

        _handleBack() {
          Log.info('Playlists:HandleBack')
          if (this.tag('PlaylistGrid').index > 0) {
            this.tag('PlaylistGrid').index = 0
          } else {
            Router.focusWidget('SideMenu')
          }
        }

        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _handleEnter() {
          Router.navigate(
            `playlistDetails/${this.tag('PlaylistGrid').currentCellItem.item.linkId}`,
            { autoPlay: false }
          )
        }

        _getFocused() {
          return this.tag('PlaylistGrid')
        }
      },
    ]
  }
}
